"use strict";
/*
This file is part of web3.js.

web3.js is free software: you can redistribute it and/or modify
it under the terms of the GNU Lesser General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

web3.js is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
GNU Lesser General Public License for more details.

You should have received a copy of the GNU Lesser General Public License
along with web3.js.  If not, see <http://www.gnu.org/licenses/>.
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTransactionGasPricing = getTransactionGasPricing;
const web3_validator_1 = require("@theqrl/web3-validator");
const web3_errors_1 = require("@theqrl/web3-errors");
const web3_utils_1 = require("@theqrl/web3-utils");
// eslint-disable-next-line import/no-cycle
const rpc_method_wrappers_js_1 = require("../rpc_method_wrappers.js");
// eslint-disable-next-line import/no-cycle
const transaction_builder_js_1 = require("./transaction_builder.js");
// 256-bit unsigned upper bound; on-chain fee fields are uint256.
const MAX_UINT256 = (BigInt(1) << BigInt(256)) - BigInt(1);
const safeBigInt = (value, label) => {
    if ((0, web3_validator_1.isNullish)(value)) {
        throw new Error(`Expected numeric ${label}, got ${String(value)}`);
    }
    if (typeof value === 'string' && value.startsWith('-')) {
        throw new Error(`Negative ${label} from RPC: ${value}`);
    }
    const result = BigInt(value);
    if (result < BigInt(0) || result > MAX_UINT256) {
        throw new Error(`${label} out of uint256 range: ${result.toString()}`);
    }
    return result;
};
function getEip1559GasPricing(transaction, web3Context, returnFormat) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const block = yield (0, rpc_method_wrappers_js_1.getBlock)(web3Context, web3Context.defaultBlock, false, returnFormat);
        const baseFeePerGas = safeBigInt(block.baseFeePerGas, 'block.baseFeePerGas');
        const maxPriorityFeePerGas = safeBigInt(((_a = transaction.maxPriorityFeePerGas) !== null && _a !== void 0 ? _a : web3Context.defaultMaxPriorityFeePerGas), 'maxPriorityFeePerGas');
        return {
            maxPriorityFeePerGas: (0, web3_utils_1.format)({ format: 'uint' }, maxPriorityFeePerGas, returnFormat),
            maxFeePerGas: (0, web3_utils_1.format)({ format: 'uint' }, ((_b = transaction.maxFeePerGas) !== null && _b !== void 0 ? _b : baseFeePerGas * BigInt(2) + maxPriorityFeePerGas), returnFormat),
        };
    });
}
function getTransactionGasPricing(transaction, web3Context, returnFormat) {
    return __awaiter(this, void 0, void 0, function* () {
        const transactionType = (0, transaction_builder_js_1.getTransactionType)(transaction, web3Context);
        if (!(0, web3_validator_1.isNullish)(transactionType)) {
            if (transactionType.startsWith('-'))
                throw new web3_errors_1.UnsupportedTransactionTypeError(transactionType);
            if (transactionType !== '0x2')
                throw new web3_errors_1.UnsupportedTransactionTypeError(transactionType);
            return Object.assign({}, (yield getEip1559GasPricing(transaction, web3Context, returnFormat)));
        }
        return undefined;
    });
}
//# sourceMappingURL=get_transaction_gas_pricing.js.map